import React, { useState, useEffect, lazy, Suspense, useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from "react-router-dom";
import CryptoJS from 'crypto-js';

import ReactGA from 'react-ga';
// This is the homepage which load in the demopage / and with login condition
import BrandLogo from "../components/brandLogo";
import AboutThree from "../components/aboutThree";
import AboutOne from "../components/aboutOne";
import AboutTwo from "../components/aboutTwo";
import AiFeatures from "../components/aiFeatures";
import Clients from "../components/clients";
import Footer from "../components/footer";

import NewSignUp from "./NewSignup";
import AIAssistantCarousel from "./AIAssistantCarousel";
import useDarkPage from '../hooks/useDarkPage';
import { useRotatingHeroAgent } from '../hooks/useRotatingHeroAgent';
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

const Features = lazy(() => import("../components/features"));
const Featuresnew = lazy(() => import("../components/featuresnew"));

export default function NewHome() {
    // One hero rotation for both pages. It lived here twice, identically,
    // and fixing one copy left the other broken for a whole build.
    // See src/hooks/useRotatingHeroAgent.js.
    const { current: heroAgent } = useRotatingHeroAgent();
    const navigate = useNavigate();
    const signupRef = useRef(null)


    const [decryptedUserId, setDecryptedUserId] = useState(null);
    // false, matching what the prerenderer captured and what every browser ends
    // at. Same fault and same fix as src/pages/pricing.js.
    const [hevolvedroid, setIshevolvedroid] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent;
        setIshevolvedroid(userAgent.includes('hevolvedroid'));
    }, []);


    useDarkPage();

    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);
    const scrollToSignup = () => {
        if (signupRef.current) {
            signupRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };



    const decryptValue = (encryptedValue) => {
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
            const originalValue = bytes.toString(CryptoJS.enc.Utf8);
            return originalValue;
        } catch (error) {
            console.error("Failed to decrypt value:", error);
            return null;
        }
    };

    useEffect(() => {
        const encryptedUserId = localStorage.getItem("user_id");
        console.log("Encrypted User ID:", encryptedUserId);

        if (encryptedUserId) {
            const userId = decryptValue(encryptedUserId);
            console.log("Decrypted User ID:", userId);
            setDecryptedUserId(userId);
        }
    }, []);

    return (
        <>
            <AIAssistantCarousel userId={decryptedUserId} />
            <AboutThree />
            <Suspense fallback={<div>Loading...</div>}>
                <Featuresnew classlist="container relative" />
            </Suspense>
            <section style={{ marginBottom: '12rem', borderRadius: '2rem' }} id="start-section" className="relative md:py-50 py-36 items-center mt-[74px] md:mx-4 overflow-hidden">
                <div style={{ borderRadius: '2rem' }} className="absolute top-0 start-0 w-full h-full z-0 pointer-events-none overflow-hidden">
                    <iframe src="https://www.youtube.com/embed/FYKHEHG02fk?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&mute=1" title="my-fram" className="absolute top-1/2 start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2 w-screen h-[56.25vw] min-h-screen md:min-w-[177.77vw] min-w-[400vw]"></iframe>
                </div>
                <div style={{ borderRadius: '2rem' }} className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/800 to-transparent"></div>
                <div className="container relative">
                    <div className="grid grid-cols-1 text-center" style={{
                        background: 'rgba(115, 120, 132, 0.2)',
                        borderRadius: '10px',
                        padding: '20px',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.18)'
                    }}>
                        <div>

                            <div style={{ flexDirection: "column", gap: "10px" }} className=" font-semibold md:font-bold flex mb-6 md:text-5xl">
                                <div className=" font-semibold md:font-bold  mb-6 md:text-5xl lg:font-bold lg:text-4xl  xl:text-4xl" >Say Hi</div>
                                <div className=" font-semibold md:font-bold  mb-6 md:text-5x lg:font-bold lg:text-4xl xl:!text-4xl
" >To Your New AI Friend</div>
                                <div className="md:flex justify-between md:font-semibold md:text-3xl  lg:!justify-around lg:font-bold lg:!text-4xl xl:text-4xl xl:justify-between">
                                    <div>Introducing HevolveAI</div>
                                    <div className="md:w-72 lg:w-[400px] xl:w-[320px]" style={{ color: heroAgent?.color }}> {heroAgent?.name}</div>
                                    <div>Agents</div></div>

                            </div>
                            <p style={{ color: '#FFF' }} className="text-lg max-w-xl mx-auto">
                                Create Your HevolveAI Agent Today In Your Language.
                            </p>
                            <div style={{ gap: '70px' }} className="flex justify-center items-center gap-7 mt-4">
                                <a href='https://play.google.com/store/apps/details?id=com.hertzai.hevolve&hl=en&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                                    className="inline-block"
                                    style={{ overflow: 'hidden' }}
                                >
                                    <img
                                        alt='Get it on Google Play'
                                        src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
                                        style={{ width: '202px', height: '80px' }}
                                    />
                                </a>

                                <button
                                    onClick={() => navigate("/agents")}
                                    style={{ color: 'black' }}
                                    className="px-4 py-2 bg-blue-600 rounded-lg transition-colors duration-300 hover:bg-blue-700 flex items-center"
                                >
                                    View All Agents
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section className="relative">

                <AboutOne />
                <AboutTwo />
                <AiFeatures />
                <section style={{ marginBottom: '12rem' }} id="signup-section">
                    <NewSignUp />
                </section>
                <Clients />
            </section>
            {
                !hevolvedroid && <Footer />
            }
        </>
    );
}
